import React from "react";

import { SvgIcon, SvgIconProps } from "@mui/material";

import { colors } from "@/theme/overrides/colors";

type Props = SvgIconProps;

const DatabaseIcon: React.FC<Props> = (props) => {
  return (
    <SvgIcon viewBox="0 0 18 19" {...props}>
      <path
        d="M18 6.5V9.5C18 11.985 13.97 14 9 14C4.03 14 0 11.985 0 9.5V6.5C0 8.985 4.03 11 9 11C13.97 11 18 8.985 18 6.5ZM0 11.5C0 13.985 4.03 16 9 16C13.97 16 18 13.985 18 11.5V14.5C18 16.985 13.97 19 9 19C4.03 19 0 16.985 0 14.5V11.5ZM9 9C4.03 9 0 6.985 0 4.5C0 2.015 4.03 0 9 0C13.97 0 18 2.015 18 4.5C18 6.985 13.97 9 9 9Z"
        fill={colors.gray}
      />
    </SvgIcon>
  );
};

export default DatabaseIcon;
